var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H15M21 8.29975V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V8.29975C3 7.50937 3.46547 6.79313 4.18772 6.47212L12 3L19.8123 6.47212C20.5345 6.79313 21 7.50937 21 8.29975ZM10 14H14C14.5523 14 15 14.4477 15 15V21H9V15C9 14.4477 9.44772 14 10 14Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2ea42fe862c19ffefaac909778393350.svg";
export { ForwardRef as ReactComponent };